import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const StyledCarouselTrack = styled.div<{
  visiblePart: number;
  isDefaultMargin: boolean;
}>`
  display: flex !important;
  flex-direction: row !important;

  ${({ isDefaultMargin }) => !isDefaultMargin && 'margin-left: 22px;!important;'}

  transform: translate(${({ visiblePart }) => visiblePart}px)!important;

  transition: transform 1s !important;
`;

export const StyledMoreCarouselButtonWrapper = styled.div<{
  icon: string;
}>`
  width: 44px !important;
  height: calc(100% - 33px) !important;
  background-color: rgba(237, 243, 246, 0.9) !important;
  position: absolute !important;
  ${({ icon }) =>
    icon === 'right'
      ? `right: -22px!important;;
    @media(max-width: 985px) {
      right: 0!important;;
    }`
      : `left: -22px!important;;
    @media(max-width: 985px) {
      left: 0!important;
    }`}
  z-index: 1!important;
`;

export const StyledMoreCarouselButton = styled.button<{
  isDisabled: boolean;
}>`
  margin-top: 18px !important;
  padding: 0 !important;
  border: none !important;
  outline: none !important;
  background: none !important;
  cursor: pointer !important;

  ${({ isDisabled }) =>
    isDisabled
      ? `opacity: 0.2!important;;
  pointer-events: none!important;;
  `
      : ''}

  transition: opacity 1s!important;

  :focus {
    outline-offset: -3px !important;
    outline: 2px dotted ${COLORS.blueCola} !important;
    background: ${COLORS.backgroundFocus} !important;
  }
`;
